import { getStateStore } from '../../stores';
import { generators } from '@playcastdotio/Messaging';
import { sendMessageToPlayer } from '../peers/host';

const state = getStateStore('ipc');

export const initializeGlobalInputEvents = () => {
  // Update player access values when global input values change
  let cachedGlobalInputState = state.globalInputState.currentState;
  state.globalInputState.addListener((newState) => {
    // find the access values that changed
    const changedAccess = Object.keys(newState).filter((key) => {
      return newState[key] !== cachedGlobalInputState[key];
    });

    // Keep touchInputConfigState in sync with globalInputState.touch
    if (changedAccess.includes('touch')) {
      console.log('[GlobalInput] Touch state changed, syncing touchInputConfigState:', {
        oldTouch: cachedGlobalInputState.touch,
        newTouch: newState.touch
      });
      state.touchInputConfigState.updateState({ enabled: newState.touch });
    }

    // update all players with the new access values, update player state store
    const playerState = state.playerState.currentState.players;
    for (const playerId in playerState) {
      const player = playerState[playerId];
      const newAccess = { ...player.access };
      changedAccess.forEach((key) => {
        newAccess[key] = newState[key];
      });
      player.access = newAccess;

      // Send direct input access message to the player
      sendMessageToPlayer(playerId, generators.player.setInputAccess(state.authState.currentState.hostAuthId, newAccess));
    }
    state.playerState.updateState({ players: { ...playerState } });
    cachedGlobalInputState = newState;
  });
};
